export const EditFormConfig: FormConfig = {
  data: [
    {
      cmpType: 'dateTime',
      fieldName: 'accidentTime',
      label: '事故发生时间',
      allowClear: false,
      labelCol: { span: 7 },
      wrapperCol: { span: 16 },
    },
    {
      cmpType: 'select',
      fieldName: 'responsible',
      label: '有无责任',
      placeholder: '请选择有无责任',
      hasSearch: false,
      allowClear: false,
      labelCol: { span: 5 },
      wrapperCol: { span: 18 },
      valueToLabel: true,
    },
    {
      cmpType: 'select',
      fieldName: 'technicalSupportAccidentLevel',
      label: '事故等级',
      placeholder: '请选择',
      hasSearch: false,
      allowClear: false,
      labelCol: { span: 5 },
      wrapperCol: { span: 18 },
      valueToLabel: true,
    },
    {
      cmpType: 'textarea',
      fieldName: 'accidentDesc',
      label: '事故描述',
      placeholder: '请输入事故描述',
      maxLength: 200,
      labelCol: { span: 5 },
      wrapperCol: { span: 18 },
    },
    {
      cmpType: 'preview',
      fieldName: 'snapshotAttachmentUrlList',
      label: '事故快照',
      labelCol: { span: 5 },
      wrapperCol: { span: 18 },
      defaultFileList: [],
      showPreviewName: true,
    },
  ],
};
